function randomId(prefix) {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `${prefix}_${crypto.randomUUID()}`;
  }
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}

function storageValue(key, prefix) {
  if (typeof window === "undefined") return "";
  try {
    const current = window.sessionStorage.getItem(key);
    if (current) return current;
    const created = randomId(prefix);
    window.sessionStorage.setItem(key, created);
    return created;
  } catch {
    return randomId(prefix);
  }
}

export function getPanelActivityIdentity() {
  if (typeof window === "undefined") return { sessionId: "", tabId: "", step: 0 };
  const sessionId = storageValue("webprofit:panel:activity-session:v2", "panel_session");
  const tabId = storageValue("webprofit:panel:activity-tab:v2", "panel_tab");
  let step = 0;
  try {
    step = Math.max(0, Number(window.sessionStorage.getItem("webprofit:panel:activity-step:v2") || 0));
  } catch {
    step = 0;
  }
  return { sessionId, tabId, step };
}

export function nextPanelActivityStep() {
  const identity = getPanelActivityIdentity();
  const step = identity.step + 1;
  try {
    window.sessionStorage.setItem("webprofit:panel:activity-step:v2", String(step));
  } catch {
    // El historial continúa aunque el navegador bloquee sessionStorage.
  }
  return { ...identity, step };
}

export function getPanelActivityHeaders() {
  const identity = getPanelActivityIdentity();
  return {
    "x-webprofit-session-id": identity.sessionId,
    "x-webprofit-tab-id": identity.tabId,
  };
}
